export const url = window.BASE_URL;